const initialState = {
  cdmdCircuito: null,
  cdmdCircuitoTotal: null,
  cdmdTotales: null,
  cdmdProdAltaComp: null,
  cdmdProdIngreso: null,
  cdmdProdCalado: null,
  cdmdProdBruto: null,
  cdmdProdDestare: null,
  cdmdProdVolcadora: null,
  cdmdCuposStopQ: null,
  cdmdExpCereal: null,
  cdmdCereal: null,
  cdmdMovimientoSilo: null,
  cartasVetadasTotal: null,
  cdmdEstadisticaCuposCereal: null,
  cdmdIngresoCompleto: null,
  // cdmdTotalesIngresoCompleto: null,
  cdmdProdAltaCompleta: null,
  camsCaladosTotalExp: null,
  camsCaladosTotalCalif: null,
  camsCaladosTotalPerito: null,
  duracionVolcado: null,
  histoCaladoPorPuesto: null,
  showTablaRemitos: false,
  uaCamionesCircuito: null,
  uaCamionesRemitosTotal: null,
  uacdmdExpCereal: null,
  wsctg: null,
  posiblesArribos: null,
  codigosDeCupo: null,
  consumidosARCA: null,
  ultimaActualizacionCDMD: null,
  actualizacionEstadoArribo: null,
  actualizacionConsumidos: null,
  actualizacionCodigosDeCupo: null
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'CUADRO_DE_MANDO_CIRCUITO':
      return {
        ...state,
        cdmdCircuito: action.cdmd
      }
    case 'CUADRO_DE_MANDO_CIRCUITO_TOTAL':
      return {
        ...state,
        cdmdCircuitoTotal: action.total
      }
    case 'CARTAS_DE_PORTE_VETADAS_TOTAL':
      return {
        ...state,
        cartasVetadasTotal: action.vetadas
      }
    case 'TOTALES_CUADRO_DE_MANDO':
      return {
        ...state,
        cdmdTotales: action.data
      }
    case 'PRODUCTIVIDAD_ALTA':
      return {
        ...state,
        cdmdProdAltaComp: action.data
      }
    case 'CUADRO_DE_MANDO_INGRESO_COMPLETO':
      return {
        ...state,
        cdmdIngresoCompleto: action.data
      }
    // case 'TOTALES_CUADRO_DE_MANDO_INGRESO_COMPLETO':
    //   return {
    //     ...state,
    //     cdmdTotalesIngresoCompleto: action.data
    //   }
    case 'PRODUCTIVIDAD_ALTA_COMPLETA':
      return {
        ...state,
        cdmdProdAltaCompleta: action.data
      }

    case 'PRODUCTIVIDAD_INGRESO':
      return {
        ...state,
        cdmdProdIngreso: action.data
      }
    case 'PRODUCTIVIDAD_CALADO':
      return {
        ...state,
        cdmdProdCalado: action.data
      }
    case 'PRODUCTIVIDAD_BRUTO':
      return {
        ...state,
        cdmdProdBruto: action.data
      }
    case 'PRODUCTIVIDAD_DESTARE':
      return {
        ...state,
        cdmdProdDestare: action.data
      }
    case 'PRODUCTIVIDAD_VOLCADORA':
      return {
        ...state,
        cdmdProdVolcadora: action.data
      }
    case 'CUPOS_STOPQ':
      return {
        ...state,
        cdmdCuposStopQ: action.data
      }
    case 'CUADRO_DE_MANDO_EXP_CEREAL':
      return {
        ...state,
        cdmdExpCereal: action.data
      }
    case 'CUADRO_DE_MANDO_CEREAL':
      return {
        ...state,
        cdmdCereal: action.data
      }
    case 'CUADRO_DE_MANDO_ESTADISTICA_CUPOS_CEREAL':
      return {
        ...state,
        cdmdEstadisticaCuposCereal: action.data
      }
    case 'CAMIONES_CALADOS_TOTAL_EXP':
      return {
        ...state,
        camsCaladosTotalExp: action.data
      }
    case 'CAMIONES_CALADOS_TOTAL_CALIF':
      return {
        ...state,
        camsCaladosTotalCalif: action.data
      }
    case 'CAMIONES_CALADOS_TOTAL_PERITO':
      return {
        ...state,
        camsCaladosTotalPerito: action.data
      }
    case 'HISTOGRAMA_CALADO_PUESTO':
      return {
        ...state,
        histoCaladoPorPuesto: action.data
      }
    case 'CUADRO_DE_MANDO_SILO':
      return {
        ...state,
        cdmdMovimientoSilo: action.data
      }
    case 'SHOW_TABLA_REMITOS':
      return {
        ...state,
        showTablaRemitos: action.newValue
      }
    case 'ESTADO_CTG_POSTERGADA':
      return {
        ...state,
        wsctg: action.wsctg['valor']
      }
    case 'ESTADO_MV_CAMIONES_CIRCUITO':
      return {
        ...state,
        uaCamionesCircuito: action.estado
      }
    case 'ESTADO_MV_REMITOS_TOTAL':
      return {
        ...state,
        uaCamionesRemitosTotal: action.estado
      }
    case 'ESTADO_MV_EXP_CEREAL':
      return {
        ...state,
        uacdmdExpCereal: action.estado
      }
    case 'DURACION_VOLCADO':
      return {
        ...state,
        duracionVolcado: action.duracionVolcado['valor']
      }
    case 'RECEIVE_POSIBLES_ARRIBOS':
      return {
        ...state,
        posiblesArribos: action.data,
        actualizacionEstadoArribo: action.fecha
      }
    case 'RECEIVE_CODIGOS_DE_CUPO':
      return {
        ...state,
        codigosDeCupo: action.data,
        actualizacionCodigosDeCupo: action.fecha
      }
    case 'ACTUALIZAR_ESTADO_ARRIBO':
      return {
        ...state,
        actualizacionEstadoArribo: action.fecha
      }
    case 'RECEIVE_CONSUMIDOS_ARCA':
      return {
        ...state,
        consumidosARCA: action.data,
        actualizacionConsumidos: action.fecha
      }
    case 'ACTUALIZACION_CONSUMIDOS_ARCA':
      return {
        ...state,
        actualizacionConsumidos: action.fecha
      }
    case 'ULTIMA_ACTUALIZACION_CDMD':
      return {
        ...state,
        ultimaActualizacionCDMD: action.fecha
      }
    default:
      return state
  }
}
